import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import * as TaskServices from "../../../../services/TaskService";
import { useTranslation } from "react-i18next";
import TaskForm from "./taskForm.view";
import PATHS from "../../../../constants/paths";
import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

const TaskFormContainer = ({ uuid }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [initValues, setInitValues] = useState({});

  const setInitialValues = useCallback(async (data) => {
    const dataFinal = {
      code: data.code,
      name: data.name,
      namePt: data.namePt,
      performance: data.performance || 0,
      culture: data.culture,
      active: data.active,
      description: data.description,
    };
    setInitValues(dataFinal);
  }, []);

  const loadData = useCallback(async () => {
    if (uuid) {
      const result = await TaskServices.getTask(uuid);
      if (result) {
        await setInitialValues(result);
      }
    }
  }, [setInitialValues, uuid]);

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (values) => {
    try {
      if (values) {
        let result = undefined;

        if (uuid) {
          result = await TaskServices.updateTask(values, uuid);
        } else {
          result = await TaskServices.addTask(values);
        }

        let title = "";
        let text = "";
        let icon = "";
        if (result) {
          if (uuid) {
            title = t("forms.task.messages.update.title");
            text = t("forms.task.messages.update.success");
            icon = "success";
          } else {
            title = t("forms.task.messages.create.title");
            text = t("forms.task.messages.create.success");
            icon = "success";
          }
        } else {
          title = "Error";
          text = t("forms.task.messages.update.error");
          icon = "error";
        }

        let okAction = () => {
          navigate(PATHS.TASK_LIST);
        };
        ShowAlertDialog(title, text, icon, false, "OK", false, okAction);
      }
    } catch (error) {
      //console.log('Error', error);
    }
  };

  const handleOnback = () => {
    navigate(PATHS.TASK_LIST);
  };

  return (
    <TaskForm
      edit={uuid ? true : false}
      initialValues={initValues}
      onSubmit={handleSubmit}
      onback={handleOnback}
    />
  );
};

TaskFormContainer.propTypes = {
  t: PropTypes.any,
};

export default TaskFormContainer;
